function Footer() {
    return (
        <div>
            <footer className="footer-nav">
                <nav>
                    <ul>
                        <li>
                            <a href="https://github.com/mrahma04?tab=repositories">
                                <i className="fa-brands fa-github" style={{
                                    fontSize: "3rem"
                                }}></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/in/mrahma04/">
                                <i className="fa-brands fa-linkedin" style={{
                                    fontSize: "3rem"
                                }}></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://stackoverflow.com/users/5597622/mrahma04?tab=profile">
                                <i className="fa-brands fa-stack-overflow" style={{
                                    fontSize: "3rem"
                                }}></i></a>
                        </li>
                    </ul>
                </nav>
            </footer>
        </div>
    )
}

export default Footer